import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8","key":"svg-0"}]]

const IconNumber2 = createReactComponent('outline', 'number-2', 'Number2', __iconNode);

export default IconNumber2;